export const TOKEN_KEY = 'Ux-Access-Token'
export const SITE_KEY='agentGuid'
export const WEB_USER='ybb-user'
export const PAGESIZE = 10
export const PAGE_SIZES = [10, 20, 50, 100]
export const PAGE_LAYOUT = 'total,  prev, pager, next, sizes,jumper'
export const FORMLABELPOSITION = 'left'
